module.exports = __webpack_public_path__ + "img/ic_ac.5abec5f8.svg";